import React from "react";
import "./style.scss";
import pinIcon from "../../../../../assets/icons/pindark.svg";
import Dropdown from 'react-bootstrap/Dropdown';
import resImg from "assets/images/reservation-img.png";
import {useHistory} from "react-router-dom";
import ButtonGroup from 'react-bootstrap/ButtonGroup';

export default function ReservationCard({ reservation}) {

  const history = useHistory();

  const getImage = (images) => {
    if (images?.length > 0) {
      return images[0]?.picture
    } else return resImg
  }

  const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
      <i
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }} className="bi bi-three-dots-vertical three-dots"/>
  ));

  const redirectToReservationDetails = (reservationId) => {

    history.push(`/my-profile/reservation-details/${reservationId}`);
  };

    return (
/*        <div className="col-xxl-4 col-xl-6 py-2 fade-in ">*/
        <div className="w-100 py-2 fade-in">
          <div className={"my-res-box"}>
            <div className="mr-topDetails">
              <img
                  src={getImage(reservation?.stand_detail?.pictures)}
                  onError={(e) => (e.target.src = resImg)}
                  alt=""
              />
              <div className="mr-land-info w-100">
                <div className="d-flex align-items-start justify-content-between">
                  <h5 className="oneline-text">{reservation?.stand_detail?.title}</h5>
                  <Dropdown className="initiate-transfer" as={ButtonGroup}>
                    <Dropdown.Toggle as={CustomToggle} drop="down-centered"/>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => redirectToReservationDetails(reservation?.id)}>
                        Reservation Detail
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div
                    className="mr-land-info cursor-pointer"
                >
                  <div className="location">
                    <img className="mt-1" src={pinIcon} alt=""/>
                    <p className="details-top bg-transparent">
                      {reservation?.stand_detail?.address}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div className="ms-listing-box-content">
              <div className="d-flex justify-content-between">
            <span className="txt-seventh">
              <strong>
                {reservation?.start_date} - {reservation?.end_date}
              </strong>
            </span>
              </div>

              <div
                  className={`d-inline-flex w-100 mt-4 ${reservation?.current_user_type == "main_hunter" ? "justify-content-between" : "justify-content-end"}`}>
                {reservation?.current_user_type == "main_hunter" ? (
                    <span className="amount">
                <strong>
                  ${reservation?.amount}
                </strong>
              </span>) : null
                }
                <div
                    className={`text-${reservation?.status === "canceled" || reservation?.status === "rejected"
                        ? "danger"
                        : reservation?.status === "paid" || reservation?.status === "completed"
                            ? "completed"
                            : reservation?.status === "approved"
                                ? "primary"
                                : "warning"
                    } d-flex align-items-center fs-14`}
                >
              <span
                  className={`dot-${reservation?.status === "canceled" || reservation?.status === "rejected"
                      ? "danger"
                      : reservation?.status === "paid" || reservation?.status === "completed"
                          ? "completed"
                          : reservation?.status === "approved"
                              ? "primary"
                              : "warning"
                  }`}
              ></span>{" "}
                  {reservation?.status?.charAt(0).toUpperCase()
                  + reservation?.status?.slice(1)}
                </div>
              </div>
            </div>
          </div>

        </div>
    );
}